<template>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <!-- Backdrop -->
    <div class="fixed inset-0 bg-black/20 backdrop-blur-[1.5px] transition-opacity"></div>

    <!-- Modal -->
    <div class="flex min-h-full items-center justify-center p-4">
      <div class="relative w-full max-w-md rounded-xl bg-white shadow-menu">
        <div class="flex flex-col gap-2 mx-4 my-10">
          <p class="text-normal-emphasis font-bold">{{ message }}</p>
          <AppButton :title="buttonTitle" :is-loading="isLoading" @click="handleConfirm" />
          <AppCancel @click="$emit('cancel')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButton from './AppButton.vue';
import AppCancel from './AppCancel.vue';

interface Props {
  message: string;
  buttonTitle?: string;
  isLoading?: boolean;
}

withDefaults(defineProps<Props>(), {
  buttonTitle: 'Delete',
  isLoading: false
});

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();

const handleConfirm = () => {
  emit('confirm');
};
</script>
